import { Injectable } from '@angular/core';

@Injectable()
export class LogService {
    constructor() {
    }
    log(object: any,data:any =false) {

        console.log(object);
        if(data)
            console.log(data);
    }
    error(object: any,data:any =false) {
        console.log(object);
        if(data)
            console.log(data);
    }
    transac(object: any,data:any =false) {
        console.log(object);
        if(data)
            console.log(data);
    }

}


// WEBPACK FOOTER //
// ./src/services/logger.ts